module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAP1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNUl8uRvN3z+PuFtdrC2uz///+py+XO4fBHj8dgns7n8Ph4rdadxOFw3Vb8AAAAB3RSTlMAYL8AIM/vi50ITwAAAJdJREFUeF7t2DkSAyEQQ9FmmwZmX+5/VkPZpE5aiV36B3i5JD3n1ZB3oSUhxKTGUuxQnNTcFBuUFFAK4hSSE4+BvCio/4QI5bIsJduhua6tOluhvH7KRmgb0GaE9gHtvwoRIkSIECFChAgRIlQGVIzQUd9OPYyQnld3rhOwju7nuTn8vkYIdrLAbh/UEQW7xpBnXQtxH74A/VKXu0dbwSgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1ee.png
// module id = 600
// module chunks = 0